module.exports = __webpack_public_path__ + "img/spritesheets.30a3ac87.png";